module.exports = __webpack_public_path__ + "img/head-side.df7bf822.svg";